import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../core/Auth'

/** Where «ثبت موبایل» opens «تکمیل حساب کاربری» for the mobile only. */
export const ACCOUNT_MOBILE_PATH = '/account/mobile'

/**
 * The hours given during an SMS outage (backend 1.0.0.757+): a reminder on every page, not closable, until the mobile
 * is registered; when they run out the server asks for the mobile before anything else.
 */
export const MobileDeferredBanner: FC = () => {
  const {currentUser} = useAuth()
  const until = currentUser?.mobileDeferredUntil
  if (!until || currentUser?.support) return null

  return (
    <div className='bg-warning-subtle border-bottom border-warning px-4 py-3' role='status'>
      <div className='d-flex flex-wrap align-items-center justify-content-between gap-3'>
        <div className='d-flex align-items-start gap-3'>
          <i className='las la-mobile-alt fs-1 text-warning-emphasis' aria-hidden='true' />
          <span className='fw-semibold text-gray-800'>
            شماره موبایل شما هنوز ثبت نشده است؛ تا {until.day} ساعت {until.time} باید آن را ثبت و
            تأیید کنید.
          </span>
        </div>
        <Link to={ACCOUNT_MOBILE_PATH} className='btn btn-sm btn-warning'>
          <i className='las la-check-circle' aria-hidden='true' /> ثبت موبایل
        </Link>
      </div>
    </div>
  )
}
